import { trackIdvGoToIdvPageClick } from "@faire/web-api--source/events/idv/click/goToIdvPage";

type IDVNavigatedFrom =
  | "OWF_ACADEMY_PAGE"
  | "CHECKOUT_PAGE"
  | "STORES_MANAGEMENT_PAGE"
  | "PREORDER_CONFIRM_IDENTITY_MODAL"
  | "OWF_PAGE"
  | "OWF_REQUEST_INFO_MODAL"
  | "ORDERS_PAGE";

export const trackGoToIdvPage = (origin: IDVNavigatedFrom) => {
  trackIdvGoToIdvPageClick(origin);
};
